export const FETCH_PRODUCTS = "FETCH_PRODUCTS";
export const  ADD_TO_CART = "ADD_TO_CART";
export const REMOVE_ITEM = "REMOVE_ITEM";
export const ADD_QUANTITY ="ADD_QUANTITY";
export const SUB_QUANTITY ="SUB_QUANTITY";
export const COMPARE_PRODUCT ="COMPARE_PRODUCT";
